//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as uiAction from '../action/uiAction';
import * as myProfileAction from '../action/myProfileAction';
import * as notificationAction from '../action/notificationAction';
import * as revisionAction from '../action/revisionAction';
import * as guideAction from '../action/guideAction';
//Mui
import { FaHome, FaEnvelope, FaSearch, FaComments, FaBars } from 'react-icons/fa';
import SettingsIcon from '@material-ui/icons/Settings';
import InfoIcon from '@material-ui/icons/Info';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import FlagIcon from '@material-ui/icons/Flag';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';


//Icon
import PersonIcon from '@material-ui/icons/Person';
import HelpIcon from '@material-ui/icons/Help';

import SearchIcon from '@material-ui/icons/Search';
import PetsIcon from '@material-ui/icons/Pets';
import StarRoundedIcon from '@material-ui/icons/Star';
import GetAppIcon from '@material-ui/icons/GetApp';

import LocalCafeRoundedIcon from '@material-ui/icons/LocalCafeRounded';
import LocalOfferRoundedIcon from '@material-ui/icons/LocalOfferRounded';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';

import partnersLogo from '../img/logo/partners_logo.png';


class Comp extends React.Component {
  constructor(props) {
    super(props);
  	this.state = {
  		menuToggleVisible: false,
      dialogChargeVisible: false,
  	}
  }


  _menuHeaderToggle() {
    if (this.props.ui.drawer) {
      this.props.drawerSet(false);
    }
    else {
      this.props.drawerSet(true);
    }
  }

	render() {
    let comp;
    if (this.props.location.pathname.match(/^\/new\//)) {
      comp = (
        <div>
          <div id='header_menu'>
            <div className="centering" style={{position:"relative"}}>
              <img
                src={ partnersLogo  }
                style={{width:'100px', height:'auto',padding:'5px'}}
                alt=''
              />
            </div>
          </div>
        </div>
      );
    }
    else if (this.props.location.pathname.match(/^\/mailbox\/(talk|support)\//)) {
      comp = null;
    }
    else if (this.props.location.pathname.match(/^\/my\/preview\//)) {
      comp = null;
    }
    else {
      comp = (
        <div>
          <div id='header_menu' className='fixed'>

            <div>
              <div className="centering" style={{position:"relative"}}>
                <ul >
                  <li>
                    <NavLink
                      to='/'
                      isActive={(match, location) => {
                        var regex = new RegExp(/^\/my/);
                        if (location.pathname === '/' || regex.test(location.pathname)) {
                          return true;
                        }
                      }}
                      activeClassName="selected"
                      onClick={ () => this.props.drawerSet(false) }
                    >
                      <div className='link'>
                        <div className='icon'><FaHome /></div>
                        <div className='text'>ホーム</div>
                      </div>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/mailbox/"
                      activeClassName="selected"
                      onClick={ () => this.props.drawerSet(false) }
                    >
                      <div className='link'>
                        <div className='icon'>
                          <FaEnvelope />
                        </div>
                        <div className='text'>メッセージ </div>
                        {
                          (this.props.notification.mailUnconfirmed > 0) &&
                          <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                            <span className='badge headerMenuBadgeAnimation'> </span>
                          </span>
                        }
                      </div>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/search/"
                      isActive={(match, location) => {
                        var regex = new RegExp(/search|footprint|favorite/);
                        if (regex.test(location.pathname)) {
                          return true;
                        }
                      }}
                      activeClassName="selected"
                      onClick={ () => this.props.drawerSet(false) }
                    >
                      <div className='link'>
                        <div className='icon'><FaSearch /></div>
                        <div className='text'>さがす</div>
                      </div>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/community/post/"
                      isActive={(match, location) => {
                        var regex = new RegExp(/community/);
                        if (regex.test(location.pathname)) {
                          return true;
                        }
                      }}
                      activeClassName="selected"
                      onClick={ () => this.props.drawerSet(false) }
                    >
                      <div className='link'>
                        <div className='icon'><FaComments /></div>
                        <div className='text'>みんなの…</div>
                      </div>
                    </NavLink>
                  </li>
                  <li>
                    <div
                      onClick={ () => this._menuHeaderToggle() } style={{cursor:'pointer'}}
                    >
                      <div className='link'>
                        <div className='icon'>
                          <FaBars />
                        </div>
                        <div className='text'>メニュー</div>
                        {
                          (this.props.notification.favoriteNoticeUnconfirmed > 0 || this.props.notification.bestpartnerUnconfirmed > 0 || this.props.notification.paymentTicketReceiverUnseen > 0) &&
                          <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                            <span className='badge headerMenuBadgeAnimation'> </span>
                          </span>
                        }
                      </div>
                    </div>
                  </li>
                </ul>


                <SwipeableDrawer
                  anchor={'right'}
                  open={this.props.ui.drawer}
                  onClose={ () => this.props.drawerSet(false) }
                  onOpen={ () => this.props.drawerSet(true) }
                >
                  <List>
                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/my/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <PersonIcon style={{color:'#3498db'}} />
                      </ListItemIcon>
                      <ListItemText primary={'マイプロフィール'} />
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/bestpartner/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <SupervisedUserCircleIcon style={{color:'#4376AB'}} />
                      </ListItemIcon>
                      <ListItemText primary={'ベストパートナー紹介'} />
                      {
                        (this.props.notification.bestpartnerUnconfirmed > 0) &&
                        <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                          <span className='badge'> </span>
                        </span>
                      }
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/search/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <SearchIcon style={{color:'#f1c40f'}} />
                      </ListItemIcon>
                      <ListItemText primary={'会員検索'} />
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/footprint/partner/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <PetsIcon style={{color:'#C79D61'}} />
                      </ListItemIcon>
                      <ListItemText primary={'足あと'} />
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/favorite/my/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <StarRoundedIcon style={{color:'#F95561'}} />
                      </ListItemIcon>
                      <ListItemText primary={'お気に入り'} />
                      {
                        (this.props.notification.favoriteNoticeUnconfirmed > 0) &&
                        <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                          <span className='badge'> </span>
                        </span>
                      }
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/memo/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <LocalOfferRoundedIcon style={{color:'#84A77F'}} />
                      </ListItemIcon>
                      <ListItemText primary={'メモ'} />
                    </ListItem>

                    {
                      (this.props.my.profile.userdata_sex === 'men') ? (
                        <ListItem
                          button
                          onClick={ () => {
                            this.props.history.push('/my/paymentTicketReceiver/');
                            this.props.drawerSet(false);
                          } }
                        >
                          <ListItemIcon>
                            <CardGiftcardIcon style={{color:'#1abc9c'}}/>
                          </ListItemIcon>
                          <ListItemText primary={'応援チケット'} />
                          {
                            (this.props.notification.paymentTicketReceiverUnseen > 0) &&
                            <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                              <span className='badge'> </span>
                            </span>
                          }
                        </ListItem>
                      ) : (
                        <ListItem
                          button
                          onClick={ () => {
                            this.props.history.push('/my/paymentTicketSender/');
                            this.props.drawerSet(false);
                          } }
                        >
                          <ListItemIcon>
                            <CardGiftcardIcon style={{color:'#1abc9c'}} />
                          </ListItemIcon>
                          <ListItemText primary={'応援チケット'} />
                          {
                            (this.props.notification.paymentTicketSenderUnused > 0) &&
                            <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                              <span className='badge'> </span>
                            </span>
                          }
                        </ListItem>
                      )
                    }

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/help/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <HelpIcon style={{color:'#E54E7C'}} />
                      </ListItemIcon>
                      <ListItemText primary={'ヘルプ'} />
                    </ListItem>

                    {
                      (this.props.my.profile.userdata_sex === 'men') ? (
                        <ListItem
                          button
                          onClick={ () => {
                            this.props.history.push('/setting/charge/');
                            this.props.drawerSet(false);
                          } }
                        >
                          <ListItemIcon>
                            <ShoppingCartIcon style={{color:'#8e44ad'}} />
                          </ListItemIcon>
                          <ListItemText primary={'有料サービス'} />
                        </ListItem>
                      ) : (
                        null
                      )
                    }
                    <ListItem
                      button
                      onClick={ () => {
                        this.props.guideAppSet(true);
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <GetAppIcon style={{color:'#16a085'}} />
                      </ListItemIcon>
                      <ListItemText primary={'アプリをインストール'} />
                      <span className='orange_icon' style={{fontSize:'0.8em'}}>おすすめ</span>
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/campaign/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <FlagIcon style={{color:'#8e44ad'}} />
                      </ListItemIcon>
                      <ListItemText primary={'キャンペーンコード'} />
                    </ListItem>


                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/news/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <NotificationsNoneIcon style={{color:'#e74c3c'}} />
                      </ListItemIcon>
                      <ListItemText primary={'お知らせ'} />
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/contact/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <InfoIcon style={{color:'#27ae60'}} />
                      </ListItemIcon>
                      <ListItemText primary={'お問い合わせ'} />
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/articles/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <LocalCafeRoundedIcon style={{color:'#f39c12'}} />
                      </ListItemIcon>
                      <ListItemText primary={'コラム'} />
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/setting/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <SettingsIcon style={{color:'#666'}} />
                      </ListItemIcon>
                      <ListItemText primary={'設定'} />
                    </ListItem>

                    <ListItem
                      button
                      onClick={ () => {
                        this.props.history.push('/logout/');
                        this.props.drawerSet(false);
                      } }
                    >
                      <ListItemIcon>
                        <ExitToAppIcon style={{color:'#95a5a6'}} />
                      </ListItemIcon>
                      <ListItemText primary={'ログアウト'} />
                    </ListItem>
                  </List>


                </SwipeableDrawer>

              </div>

            </div>

          </div>

          <div id='header_menu_spacer'></div>
        </div>
      )
    }

    return comp;
	}
}

const mapStateToProps = (state) => {
	return {
    ui: state.ui,
    my: state.my,
    notification: state.notification,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...uiAction,
    ...myProfileAction,
    ...notificationAction,
    ...revisionAction,
    ...guideAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
